"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zIndex = {
    modal: 1300,
    tooltip: 1500
};
exports.default = zIndex;
//# sourceMappingURL=z-index.js.map